'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _GeneratedEmailModal = require('../page-case/GeneratedEmailModal');

var _GeneratedEmailModal2 = _interopRequireDefault(_GeneratedEmailModal);

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GeneratedEmail = (_dec = (0, _mobxReact.inject)(), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(GeneratedEmail, _Component);

  function GeneratedEmail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GeneratedEmail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeneratedEmail.__proto__ || Object.getPrototypeOf(GeneratedEmail)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showModal', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GeneratedEmail, [{
    key: 'onClick',
    value: function onClick() {
      var viewDetails = this.props.viewDetails;


      if (viewDetails) {
        this.showModal.setTrue();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$activity = this.props.activity,
          has_attachments = _props$activity.has_attachments,
          subject = _props$activity.subject,
          to_emails = _props$activity.to_emails,
          activity_body = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Email ',
          has_attachments && _react2.default.createElement(_common.Icon, { className: 'attachments', type: 'paperclip' })
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h4',
            null,
            'To:'
          ),
          ' ',
          to_emails.join(', ')
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h4',
            null,
            'Subject:'
          ),
          ' ',
          subject
        ),
        this.showModal.isTrue && _react2.default.createElement(_GeneratedEmailModal2.default, { onClose: this.showModal.setFalse, activity: this.props.activity })
      );

      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: activity_body,
        truncatedBody: activity_body,
        dot: 'icon',
        icon: 'envelope',
        onClick: this.onClick
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return GeneratedEmail;
}(_react.Component), _class3.propTypes = {
  activity: _propTypes2.default.shape({
    has_attachments: _propTypes2.default.bool,
    id: _propTypes2.default.string.isRequired,
    subject: _propTypes2.default.string.isRequired,
    to_emails: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  viewDetails: _propTypes2.default.bool
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
})), _class2)) || _class) || _class) || _class);
var _default = GeneratedEmail;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GeneratedEmail, 'GeneratedEmail', '/app/src/components/common-activities/GeneratedEmail.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/GeneratedEmail.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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